import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-spinner-large.tsx
/**
* icon.24.spinner.large
*
* Keywords: refresh, reload, clockwise, rotation, circular, arrow, update, sync
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTYuNDQ1IDUuMzQ4QTggOCAwIDAgMCAxMi41IDQuMDE2LjUyNS41MjUgMCAwIDEgMTIgMy41YS40OC40OCAwIDAgMSAuNS0uNDg2QTkgOSAwIDEgMSAzLjAxNCAxMi41LjQ4LjQ4IDAgMCAxIDMuNSAxMmMuMjc2IDAgLjQ5OC4yMjQuNTE2LjVhOCA4IDAgMSAwIDEyLjQyOS03LjE1MiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2008
*/
const Icon24SpinnerLarge = memo(function Icon24SpinnerLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M16.445 5.348A8 8 0 0 0 12.5 4.016.525.525 0 0 1 12 3.5a.48.48 0 0 1 .5-.486A9 9 0 1 1 3.014 12.5.48.48 0 0 1 3.5 12c.276 0 .498.224.516.5a8 8 0 1 0 12.429-7.152",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24SpinnerLarge };

//# sourceMappingURL=icon-24-spinner-large.js.map